import axios from "axios";

const URL = "https://gateway.hyundaicolombia.co/";

export const PosventaAll = async () => {
  return await axios.get(
    URL +
      "post-sales/all"
  );
};
